import { createSlice, current } from "@reduxjs/toolkit";

const initialState = { sideNavBarTabs: [] };

export const sideNavBarTabsSlice = createSlice({
  name: "sideNavBarTabs",
  initialState,
  reducers: {
    setSideNavBarTabs: (state, action) => {
      state.sideNavBarTabs = action.payload;
    },

    resetSideNavBarTabs: (state, action) => {
      state.sideNavBarTabs = [];
    },

    updatePendingTasksCount: (state, action) => {
      const pathItems = window.location.pathname.split("/");
      const tabName = pathItems[2]
        .split("-")
        .map((str) => str.charAt(0).toUpperCase() + str.slice(1))
        .join(" ");
      const subTabName = pathItems[3].split("-").join(" ");

      state.sideNavBarTabs = state.sideNavBarTabs.map((tab) => {
        if (tab.name === tabName) {
          return {
            ...tab,
            subTabs: tab.subTabs.map((subTab) => {
              if (subTab.name.toLowerCase() === subTabName) {
                return { ...subTab, count: action.payload };
              } else {
                return subTab;
              }
            }),
          };
        } else {
          return tab;
        }
      });
    },
  },
});

export const {
  setSideNavBarTabs,
  resetSideNavBarTabs,
  updatePendingTasksCount,
} = sideNavBarTabsSlice.actions;

export default sideNavBarTabsSlice.reducer;
